import api from './CHN01-channels.api';
import EventBus from '../../common/event-bus/event-bus';
import {CSATORNA_KIOSZTASOK} from '../../common/api/urls';
import VueScrollTo from 'vue-scrollto';
import chn01Channel from './CHN01-channel';
import { SCROLL_DURATION } from '../../common/constants/constants';

const CHANNEL_FORMAT_SD = 'SD';
const HELYI_TV = /(helyi)/gi;
const TIPUS = {
	TV: 'tv',
	RADIO: 'radio'
};

export default {
	components: {
		chn01Channel
	},
	data() {
		return {
			isFiltersOpen: false,
			hasMoreFiltersThanCanFit: false,
			listView: false,
			channelPackages: {},
			filters: [],
			hasError: false,
			isLoading: false,
			mobilTVFilter: false,
			tvPackageIds : []
		};
	},
	props: [
		'filters-container-selector',
		'filter-item-selector'
	],
	computed: {
		filteredChannelPackages() {
			let filteredChannelPackages = {};

			if (this.hasActiveFilter) {
				let filters = this.filters;
				for (let channelPackage in this.channelPackages) {
					let channelPackageToFilter = this.channelPackages[channelPackage];
					let filteredChannels = channelPackageToFilter.filter((channel) => {
						let isFiltered = filters.some((filter) => {
							return filter.name === channel.jelleg && filter.isActive;
						});
						let isMobilTv = channel.mobilTv;
						return this.mobilTVFilter ? isFiltered || isMobilTv : isFiltered;
					});
					filteredChannelPackages[channelPackage] = filteredChannels;
				}
			} else {
				// if no active filter is set then return all channels
				filteredChannelPackages = this.channelPackages;
			}

			return filteredChannelPackages;
		},
		hasActiveFilter() {
			return this.filters.some((filter) => {
				return filter.isActive;
			}) || this.mobilTVFilter;
		},
		allTvPackageIdString() {
			return this.tvPackageIds.join();
		},
		pdfDownloadUrl() {
			return `${CSATORNA_KIOSZTASOK}/csatornakiosztas-pdf?szolgaltatasId=${this.allTvPackageIdString}&sessionId=${window.sessionId}`;
		},
		pathIncludesServiceId() {
			return window.location.href.includes('?serviceId=');
		}
	},
	methods: {
		filterWithoutHelyTvAndRadio(channels) {
			return channels.filter(channel => !this.isHelyiTv(channel) && channel.tipus != TIPUS.RADIO);
		},
		filterByHelyiTv(channels) {
			return channels.filter(channel => this.isHelyiTv(channel));
		},
		isHelyiTv(channel) {
			let isHelyiTv = false;
			if (channel.jelleg) {
				isHelyiTv = isHelyiTv ? isHelyiTv : HELYI_TV.test(channel.jelleg);
			}
			if (channel.kategoria) {
				isHelyiTv = isHelyiTv ? isHelyiTv : HELYI_TV.test(channel.kategoria);
			}
			return isHelyiTv && channel.tipus == TIPUS.TV;
		},
		filterByRadio(channels) {
			return channels.filter(channel => channel.tipus == TIPUS.RADIO);
		},
		toggleMobilTVFilter() {
			this.mobilTVFilter = !this.mobilTVFilter;
		},
		checkFilterItemsBiggerThanContainter() {
			// calculate filter button sizes and check if they are bigger than their container
			// if they are, then a 'more' button is needed to be displayed
			if (this.$el) {
				let filterContainer = this.$el.querySelector(this.filtersContainerSelector);
				let filterContainerSize = filterContainer.offsetWidth;
				let filterElements = this.$el.querySelectorAll(this.filterItemSelector);
				let filterElementsSize = 0;

				filterElements.forEach((element) => {
					filterElementsSize += element.offsetWidth;
				});

				this.hasMoreFiltersThanCanFit = filterElementsSize > filterContainerSize;
			}
		},
		getChannels(serviceId) {
			this.isLoading = true;
			return api.getChannels(serviceId)
				.then(response => response)
				.catch(() => {
					this.isLoading = false;
					this.hasError = true;
				});
		},
		getServices(commitmentPeriodId) {
			this.isLoading = true;
			return api.getServices(commitmentPeriodId)
				.then(response => {
					let tvPackages = response.data.tv;
					let tvPackageIds = [];

					tvPackages.forEach((tvPackage) => {
						tvPackageIds.push(tvPackage.szolgaltatasCsomagId);
					});
					this.tvPackageIds = tvPackageIds;

					return tvPackageIds;
				});
		},
		getChannelsForSinglePackage(serviceId) {
			let promise = new Promise(resolve => {
				this.getChannels(serviceId).then(response => resolve(response));
			});
			promise.then(response => {
				let channelPackages = response.data.csatornak || {};
				let filters = response.data.jellegek || [];
				let channelPackagesToDisplay = {};

				for (let channelPackage in channelPackages) {
					let channels = [];
					for (let channel of channelPackages[channelPackage]) {
						let channelToDisplay = channel;
						channelToDisplay.isOpen = false;
						channelToDisplay.marketing = {
							cim: channelToDisplay.channelName,
							szoveg: channelToDisplay.channelModal
						};

							channels.push(channelToDisplay);
					}
					channelPackagesToDisplay[channelPackage] = channels;
				}
				let filtersToDisplay = [];
				for (let filter of filters) {
					filtersToDisplay.push({
						name: filter,
						isActive: false
					});
				}
				this.isLoading = false;
				this.hasError = false;
				this.channelPackages = Object.assign({}, this.channelPackages, channelPackagesToDisplay);
				let filtersLength = this.filters.length;
				if (filtersLength === 0) {
					// put all elements in the array
					this.filters = filtersToDisplay;
				} else {
					// check for duplicates
					let filtersToDisplayLength = filtersToDisplay.length;
					for (let i = 0; i < filtersToDisplayLength; i++) {
						let filterToCheck = filtersToDisplay[i];
						let indexInFilters = this.filters.findIndex((filter) => {
							return filter.name === filterToCheck.name;
						});
						if (indexInFilters === -1) {
							this.filters.push(filterToCheck);
						}
					}
				}
			});
			this.$nextTick(()=>{
				// ha van az url-ben akkor oda görgetünk
				let anchor = decodeURIComponent(window.location.href.replace(/.*#/g, ''));
				let reference = this.$refs['channelsContainer' + anchor];
				if (anchor && reference) {
					VueScrollTo.scrollTo(reference[0], SCROLL_DURATION);
				}
			});
		},
		getChannelsForEveryPackage(commitmentPeriodId) {
			this.getServices(commitmentPeriodId)
				.then(tvPackageIds => {
					if (tvPackageIds.length) {
						let promises = tvPackageIds.map(tvPackageId => {
							return new Promise(resolve => {
								this.getChannels(tvPackageId).then(response => resolve(response));
							});
						});
						Promise.all(promises).then(responses => {
							responses.forEach(response => {
								let channelPackages = response.data.csatornak || {};
								let filters = response.data.jellegek || [];
								let channelPackagesToDisplay = {};

								for (let channelPackage in channelPackages) {
									let channels = [];
									for (let channel of channelPackages[channelPackage]) {
										let channelToDisplay = channel;
										channelToDisplay.isOpen = false;
										// TODO: ha kész a backend ezen része, akkor már ez nem fog kelleni
										// channelToDisplay.hd = channel.nev.slice(-2) === 'HD';
										channelToDisplay.marketing = {
											cim: channelToDisplay.channelName,
											szoveg: channelToDisplay.channelModal
										};

										channels.push(channelToDisplay);
									}
									channelPackagesToDisplay[channelPackage] = channels;
								}

								let filtersToDisplay = [];
								for (let filter of filters) {
									filtersToDisplay.push({
										name: filter,
										isActive: false
									});
								}

								this.isLoading = false;
								this.hasError = false;
								this.channelPackages = Object.assign({}, this.channelPackages, channelPackagesToDisplay);

								let filtersLength = this.filters.length;
								if (filtersLength === 0) {
									// put all elements in the array
									this.filters = filtersToDisplay;
								} else {
									// check for duplicates
									let filtersToDisplayLength = filtersToDisplay.length;
									for (let i = 0; i < filtersToDisplayLength; i++) {
										let filterToCheck = filtersToDisplay[i];
										let indexInFilters = this.filters.findIndex((filter) => {
											return filter.name === filterToCheck.name;
										});
										if (indexInFilters === -1) {
											this.filters.push(filterToCheck);
										}
									}
								}
							});
							this.$nextTick(()=>{
								// ha van az url-ben akkor oda görgetünk
								let anchor = decodeURIComponent(window.location.href.replace(/.*#/g, ''));
								let reference = this.$refs['channelsContainer' + anchor];
								if (anchor && reference) {
									VueScrollTo.scrollTo(reference[0], SCROLL_DURATION);
								}
							});
						});
					}
				});
		},
		toggleFilter(filterIndex) {
			this.filters[filterIndex].isActive = !this.filters[filterIndex].isActive;
		},
		toggleFilters() {
			this.isFiltersOpen = !this.isFiltersOpen;
		},
		toggleListView(type) {
			this.listView = !this.listView;
			this.$nextTick(()=>{
				this.$scrollTo(this.$refs['channelsContainer' + type][0]);
			});
		},
		calculateHd(channels) {
			return channels.filter((channel) => {
				return channel.formatum && channel.formatum != CHANNEL_FORMAT_SD;
			}).length;
		},
		dismissError() {
			this.hasError = false;
		},
		getServiceIdFromUrl() {
			let location = window.location.href;
			let serviceId = location.slice(location.indexOf('=') + 1, location.indexOf('&'));
			return serviceId;
		}
	},
	watch: {
		'$mq.resize': 'checkFilterItemsBiggerThanContainter'
	},
	mounted() {
		if (this.pathIncludesServiceId) {
			this.channelPackages = {};
			this.filters = [];
			this.getChannelsForSinglePackage(this.getServiceIdFromUrl());
		}
		EventBus.$on('on-current-address-changed', () => {
			this.channelPackages = {};
			this.filters = [];
			if (this.pathIncludesServiceId) {
				this.getChannelsForSinglePackage(this.getServiceIdFromUrl());
			} else {
				this.getChannelsForEveryPackage();
			}
		});
	},
	updated() {
		this.checkFilterItemsBiggerThanContainter();
	}
};



// WEBPACK FOOTER //
// ../source/modules/CHN01-channels/CHN01-channels.js